export const DEVELOPMENT = "development";

export const SERVER_CONNECTION = 'SERVER_CONNECTION';
export const PRELOADER = 'PRELOADER';
export const PRELOADER_STATE = 'PRELOADER_STATE';
export const GET_TALES = 'GET_TALES';
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const GET_ADVENTURES = 'GET_ADVENTURES';
export const SET_PAGE = 'SET_PAGE';
export const LOGIN = 'LOGIN';
export const SOUND_MUSIC = 'SOUND_MUSIC';
export const SOUND_BUTTONS = 'SOUND_BUTTONS';
export const SOUND_ENVIRONMENT = 'SOUND_ENVIRONMENT';
export const SOUND_MUSIC_VOLUME = 'SOUND_MUSIC_VOLUME';
export const SOUND_BUTTONS_VOLUME = 'SOUND_BUTTONS_VOLUME';
export const SOUND_ENVIRONMENT_VOLUME = 'SOUND_ENVIRONMENT_VOLUME';
export const SHOW_MENU = 'SHOW_MENU';
export const SOUND_ALERT = 'SOUND_ALERT';
export const SET_CHARACTER = 'SER_CHARACTER';
export const SHOW_AGAIN_SOUND_ALERT = 'SHOW_AGAIN_SOUND_ALERT';

export const LIST_IMAGES = [
    {
        home:
        [
            '../design/WoG-Icon.png', 
            '../design/background-div-enter.png', 
            '../design/background-div-aventuras.png'
        ] 
    },
    {
        gwerh:[
            '../design/background-gwerh.png'
        ]
    }
];
